import { createAction } from "@reduxjs/toolkit";
import type { IGetFeedResponse } from "./feed-api";
import type { IGetFeedConfig } from "./feed-helpers";
import type { IFeedInfo } from "./feed-models";

export namespace IFeedActions {
  export enum Type {
    GET__FEED__INIT = "GET__FEED__INIT",
    GET__FEED__SUCCESS = "GET__FEED__SUCCESS",

    POST__FEED__INIT = "POST__FEED__INIT",
    POST__FEED__PROGRESS = "POST_FEED_PROGRESS",
    POST__FEED__SUCCESS = "POST__FEED__SUCCESS",
    POST__FEED__FAILURE = "POST__FEED__FAILURE",

    // FEED_ITEM_PATCHED carries the one cross-store side effect patching a
    // feed item has beyond its own request status: syncing the patched
    // item into `feeds`.
    FEED_ITEM_PATCHED = "FEED_ITEM_PATCHED",

    SET__UNREAD_FEEDS = "SET__UNREAD_FEEDS",

    // DELETE__FEED_ITEM_BY_ID__INIT = 'DELETE__FEED_ITEM_BY_ID__INIT',
    // DELETE__FEED_ITEM_BY_ID__SUCCESS = 'DELETE__FEED_ITEM_BY_ID__SUCCESS',
    // DELETE__FEED_ITEM_BY_ID__FAILURE = 'DELETE__FEED_ITEM_BY_ID__FAILURE',

    // PATCH__FEED_ITEM_BY_ID__INIT = 'PATCH__FEED_ITEM_BY_ID__INIT',
    // PATCH__FEED_ITEM_BY_ID__SUCCESS = 'PATCH__FEED_ITEM_BY_ID__SUCCESS',
    // PATCH__FEED_ITEM_BY_ID__FAILURE = 'PATCH__FEED_ITEM_BY_ID__FAILURE',

    // GET__FEED_BY_ID__INIT = 'GET__FEED_BY_ID__INIT',
    // GET__FEED_BY_ID__SUCCESS = 'GET__FEED_BY_ID__SUCCESS',
    // GET__FEED_BY_ID__FAILURE = 'GET__FEED_BY_ID__FAILURE',

    // DELETE__FM_FEED_ITEM_BY_ID__INIT = 'DELETE__FM_FEED_ITEM_BY_ID__INIT',
    // DELETE__FM_FEED_ITEM_BY_ID__SUCCESS = 'DELETE__FM_FEED_ITEM_BY_ID__SUCCESS',
    // DELETE__FM_FEED_ITEM_BY_ID__FAILURE = 'DELETE__FM_FEED_ITEM_BY_ID__FAILURE',

    // PATCH__FM_FEED_ITEM_BY_ID__INIT = 'PATCH__FM_FEED_ITEM_BY_ID__INIT',
    // PATCH__FM_FEED_ITEM_BY_ID__SUCCESS = 'PATCH__FEED_ITEM_BY_ID__SUCCESS',
    // PATCH__FM_FEED_ITEM_BY_ID__FAILURE = 'PATCH__FEED_ITEM_BY_ID__FAILURE',

    // GET__FOLLOWING__INIT = 'GET__FOLLOWING__INIT',
    // GET__FOLLOWING__SUCCESS = 'GET__FOLLOWING__SUCCESS',
    // GET__FOLLOWING__FAILURE = 'GET__FOLLOWING__FAILURE'
  }
  export const initGetFeed = createAction<{
    config: Pick<IGetFeedConfig, "isForceLoader">;
  }>(Type.GET__FEED__INIT);
  export const successGetFeed = createAction<{
    config: IGetFeedConfig;
    res: IGetFeedResponse;
  }>(Type.GET__FEED__SUCCESS);

  export const initPostFmFeed = createAction<{
    clientSideFeedItem: IFeedInfo;
  }>(Type.POST__FEED__INIT);
  export const progressPostFmFeed = createAction<{
    clientSideFeedItem: IFeedInfo;
  }>(Type.POST__FEED__PROGRESS);
  export const successPostFmFeed = createAction<{
    res: IFeedInfo;
    clientSideId: string;
  }>(Type.POST__FEED__SUCCESS);
  export const failurePostFmFeed = createAction<{
    clientSideFeedItem: IFeedInfo;
  }>(Type.POST__FEED__FAILURE);

  export const feedItemPatched = createAction<{ data: IFeedInfo }>(
    Type.FEED_ITEM_PATCHED
  );

  export const setUnreadFeeds = createAction<number>(Type.SET__UNREAD_FEEDS);
}

export type FeedActions = Omit<typeof IFeedActions, "Type">;
